<template>
  <transition name="fade">
    <div v-if="modelValue" class="full-page-alert">
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
const modelValue = defineModel<boolean>();
</script>

<style scoped lang="scss">
.full-page-alert {
  position: fixed;
  inset: 0;
  z-index: $z-index-10;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 40px 20px;
  overflow: auto;

  background-color: rgba($white-color, 0.8);
}
</style>
